import { useEffect, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import IconsMyPlan from '../../assets/icones_meu_plano.svg';
import IconsMyContacts from '../../assets/icones_meus_contatos.svg';
import IconsConnections from '../../assets/icones_minhas_conexoes.svg';
import IconsLastAccess from '../../assets/icones_ultimo_acesso.svg';
import DailyConsumptionChart from '../../components/Charts/DailyConsumptionChart';
import { saveFacebookToken } from '../../helpers/localStorage';
import { useGetInfoQuery } from '../../services/auth';
import { useGetCustomerByIdQuery } from '../../services/customer/customer-service';
import { useGetDashboardDataQuery } from '../../services/dashboard';
import { useGetFacebookTokenQuery } from '../../services/facebookAuth';
import { Body, H4 } from '../../styles/fonts';
import {
  Body1,
  IconCard,
  IconCardContent,
  PageHeader,
  Row01,
  Section,
  SystemSettings,
} from './styles';

const Home = () => {
  const { data: facebookLongToken } = useGetFacebookTokenQuery();
  const { data: dashboardFiles, isFetching } = useGetDashboardDataQuery({});
  const [dashboardData, setDashboardData] = useState<any[]>([]);
  const [greeting, setGreeting] = useState<string>('');
  const [userName, setUserName] = useState<string>('');
  const [cachedDashboardFiles, setCachedDashboardFiles] = useState<any[]>([]);
  const { data: info } = useGetInfoQuery();
  const { data: customer } = useGetCustomerByIdQuery(info?.customer || '', {
    skip: !info?.customer,
  });

  const processDashboardFiles = (array: any[]) => {
    const pfData = array.filter((item: any) => item.customerType === 'PF');
    const pjData = array.filter((item: any) => item.customerType === 'PJ');
    setDashboardData([...pfData, ...pjData]);
  };

  const getGreeting = () => {
    const currentHour = new Date().getHours();
    if (currentHour < 12) return 'Bom dia';
    if (currentHour < 18) return 'Boa tarde';
    return 'Boa noite';
  };

  useEffect(() => {
    if (facebookLongToken) {
      saveFacebookToken(facebookLongToken.accessToken as string);
    }
  }, [facebookLongToken]);

  useEffect(() => {
    const cached = JSON.parse(localStorage.getItem('files') || 'null');
    if (cached) {
      setCachedDashboardFiles(cached);
      processDashboardFiles(cached);
    }
  }, []);

  useEffect(() => {
    if (dashboardFiles) {
      localStorage.setItem('files', JSON.stringify(dashboardFiles));
      setCachedDashboardFiles(dashboardFiles);
      processDashboardFiles(dashboardFiles);
    }
  }, [dashboardFiles]);

  useEffect(() => {
    const authData = JSON.parse(localStorage.getItem('auth') as string);
    setUserName(authData.name);
    setGreeting(getGreeting());
  }, []);

  const renderInfoCard = (value: string | number, label: string, icon: any) => (
    <IconCard
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 160,
      }}
    >
      <IconCardContent
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <H4 weight="medium" style={{ margin: 0 }}>
          {value?.toLocaleString('pt-BR')}
        </H4>
        <Body style={{ color: '#888', fontSize: '1.1rem', marginBottom: 8 }}>
          {label}
        </Body>
        <img
          src={icon}
          alt={label}
          style={{ width: 40, height: 40, marginTop: 8 }}
        />
      </IconCardContent>
    </IconCard>
  );

  return (
    <SystemSettings>
      <PageHeader>
        <H4 weight="medium">
          {greeting}, {userName}
        </H4>
      </PageHeader>

      <Body1>
        <Section>
          {/* Bloco de informações principais */}
          <Row01
            style={{
              display: 'flex',
              gap: 32,
              justifyContent: 'center',
              marginBottom: 32,
            }}
          >
            {(() => {
              const user = dashboardData.find(u =>
                customer?.customerType
                  ? u.customerType === customer.customerType
                  : true,
              );
              if (!user) return null;
              return (
                <>
                  {renderInfoCard(
                    user.planDescription,
                    'Meu plano',
                    IconsMyPlan,
                  )}
                  {renderInfoCard(
                    user.segmentations,
                    'Segmentações',
                    IconsLastAccess,
                  )}
                  {renderInfoCard(
                    user.contacts,
                    'Meus contatos',
                    IconsMyContacts,
                  )}
                  {renderInfoCard(
                    user.connections,
                    'Minhas conexões',
                    IconsConnections,
                  )}
                </>
              );
            })()}
          </Row01>

          {/* Novo Gráfico de Consumo Diário */}
          <div
            style={{
              width: '100%',
              marginTop: 40,
              display: 'block',
            }}
          >
            {cachedDashboardFiles.length === 0 && isFetching ? (
              <Skeleton width="100%" height={500} />
            ) : (
              <DailyConsumptionChart />
            )}
          </div>
        </Section>
      </Body1>
    </SystemSettings>
  );
};

export default Home;
